import type { addRecommendedLineupToCartInput as AddRecommendedLineupToCartInput } from '@sorare/core/src/__generated__/globalTypes';
import {
  Sport,
  SupportedCurrency,
} from '@sorare/core/src/__generated__/globalTypes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

type Props<T> = {
  mutate: ({
    variables,
  }: {
    variables: { input: AddRecommendedLineupToCartInput };
  }) => Promise<{
    data: T | null | undefined;
    errors: {
      message: string;
      code?: number;
    }[];
    success: boolean;
  }>;
};

export const useAddRecommendedLineupToCart = <T>({ mutate }: Props<T>) => {
  const {
    flags: { recommendedLineupBudget = { limited: 50, rare: 100 } },
  } = useFeatureFlags();
  const { currentUser } = useCurrentUserContext();

  const currency =
    currentUser?.userSettings.fiatCurrency || SupportedCurrency.USD;

  const addRecommendedLineupToCart = async ({
    so5LeaderboardSlug,
    rarity,
    teamSlugs,
  }: {
    so5LeaderboardSlug: string;
    teamSlugs: string[];
    rarity: string;
  }) => {
    return await mutate({
      variables: {
        input: {
          sport: Sport.FOOTBALL,
          amount: {
            amount: recommendedLineupBudget[rarity || 'limited'].toString(),
            currency,
          },
          teamSlugs,
          so5LeaderboardSlug,
        },
      },
    });
  };

  return addRecommendedLineupToCart;
};
